import * as React from "react";
import {
  Button,
  Card,
  Chip,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
  Box,
  IconButton,
  Tab,
  CardContent,
  Grid,
  Select,
  MenuItem,
  Link,
  Tooltip,
} from "@mui/material";
import {
  GridColDef,
  GridRenderCellParams,
  GridValueGetterParams,
} from "@mui/x-data-grid";
import { useSelector } from "react-redux";
import LinearProgress, {
  LinearProgressProps,
} from "@mui/material/LinearProgress";
import SyncIcon from "@mui/icons-material/Sync";
import {
  useGetProductAggregatesMutation,
  useGetShopifyProductsMutation,
  useSyncShopifyToAggregateMutation,
  useGetSyncStatusMutation,
  useSetIsSyncingV2Mutation,
  useQuickSyncMutation,
} from "../../../redux/reducer/features/Integration/DmsSetupSlice";
import AddCircleIcon from "@mui/icons-material/AddCircleOutline";
import CloseIcon from "@mui/icons-material/Close";
import { AppState } from "../../../redux/reducer/rootReducer";
import { useDispatch } from "react-redux";
import {
  setSetupId,
  setSyncing,
  setSyncStatus,
} from "../../../redux/reducer/features/Auth/authSlice";
import {
  ProductType,
  PricingType,
} from "../../../models/features/Integration/DmsSetup";
import ServerAppGrid from "../../app/ServerAppGrid";
import { AppFilter } from "../../../models/app/AppModels";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import ShopifyProductGrid from "./Grids/ShopifyProductGrid";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import {
  useGetProductByIdMutation,
  useRemoveAggregateProductAsyncMutation,
  useRemoveBulkAggregateProductsMutation,
} from "../../../redux/reducer/features/Product/productSlice";
import { Product } from "../../../models/features/Product/Product";
import ProductDetail from "../DmsSetup/Popup/ProductDetail";
import PageLoader from "../../app/PageLoader";
import { AppGridId } from "../../../models/app/AppGridModels";
import { GetAppGridColumns } from "../../../services/utilities/utility";
import { customPriceFilterOperators } from "../../app/CustomGridFilterOpereators";
interface SyncProductProps {}

const SyncProduct: React.FunctionComponent<SyncProductProps> = (props) => {
  const WGgridSetting = useSelector((state: AppState) =>
    state?.AppGridReducer?.setting.find(
      (x) => x.gridId === AppGridId.Product_Sync_Wholegoods
    )
  );
  const PartgridSetting = useSelector((state: AppState) =>
    state?.AppGridReducer?.setting.find(
      (x) => x.gridId === AppGridId.Product_Sync_Parts
    )
  );
  const [paging, setPaging] = React.useState<AppFilter>({
    pageIndex: 0,
    pageSize: 10,
    totalRecords: 0,
    items: [],
    quickFilterValues: [],
  });
  const [partsPaging, setPartsPaging] = React.useState<AppFilter>({
    pageIndex: 0,
    pageSize: 10,
    totalRecords: 0,
    items: [],
    quickFilterValues: [],
  });

  const [shopifyPaging, setShopifyPaging] = React.useState<AppFilter>({
    pageIndex: 0,
    pageSize: 10,
    totalRecords: 0,
    items: [],
    quickFilterValues: [],
  });

  const setupId = useSelector((state: AppState) => state.authReducer.setupId);
  const { dmsSetup } = useSelector((state: AppState) => state.authReducer);
  const { syncedProductAggregateEventData } = useSelector(
    (state: AppState) => state.dmsReducer
  );
  const productTypes = useSelector(
    (state: AppState) => state.authReducer.dmsSetup?.productTypes
  );

  const dispatch = useDispatch();
  const [selectedRowData, setSelectedRowData] = React.useState<any>();
  const [productType, setProductType] = React.useState(0);
  const [productsCount, setProductsCount] = React.useState<number>(0);
  const [partsCount, setPartsCount] = React.useState<number>(0);
  const [shopifyProductsCount, setShopifyProductsCount] =
    React.useState<number>(0);
  const [popup, setPopup] = React.useState(false);
  const [products, setProducts] = React.useState<any[]>([]);
  const [parts, setParts] = React.useState<any[]>([]);
  const [shopifyProducts, setShopifyProducts] = React.useState<any[]>([]);
  const [isSyncing, setIsSyncing] = React.useState(false);
  const [productDeleteConfirm, setProductDeleteConfirm] = React.useState(false);
  const [selectedProductId, setSelectedProductId] = React.useState("");
  const [productAggSelectedRows, setProductAggSelectedRows] =
    React.useState<any>([]);
  const [deleteBulkProductsConfirm, setDeleteBulkProductsConfirm] =
    React.useState(false);
  const [openDetail, setOpenDetail] = React.useState(false);
  const [selectedProductDetail, setSelectedProductDetail] =
    React.useState<Product>();
  const [openSync, setOpenSync] = React.useState(false);
  const [value, setValue] = React.useState("Wholegoods");
  const [priceType, setPriceType] = React.useState(PricingType.Price);
  const [productToSync, setProductToSync] = React.useState<{
    selectedProductId: string;
    productIds: string[];
  }>({
    selectedProductId: "",
    productIds: [],
  });

  const [counts, setCounts] = React.useState<{
    totalCount: number;
    syncedCount: number;
    isWholegoodSyncing: boolean;
    isPartSyncing: boolean;
  }>({
    totalCount: 0,
    syncedCount: 0,
    isPartSyncing: false,
    isWholegoodSyncing: false,
  });

  const [shopifyProductStatus, setShopifyProductStatus] = React.useState("all");
  const handleSelectChange = (event: any) => {
    setShopifyProductStatus(event.target.value);
  };
  const [getSyncStatusMutation, getSyncStatusMutationResult] =
    useGetSyncStatusMutation();
  const [getWholegoodsAggregate, getWholegoodsAggregateResult] =
    useGetProductAggregatesMutation();
  const [getPartsAggregate, getPartsAggregateResult] =
    useGetProductAggregatesMutation();
  const [shopifyProductsMutation, shopifyProductsMutationResult] =
    useGetShopifyProductsMutation();
  const [setSyncingMutation, setSyncingMutationResult] =
    useSetIsSyncingV2Mutation();
  const [addShopifyToAggregate, addShopifyToAggregateMutationResult] =
    useSyncShopifyToAggregateMutation();
  const [deleteProductMutation, deleteProductMutationResult] =
    useRemoveAggregateProductAsyncMutation();
  const [deleteBulkProductsMutation, deleteBulkProductsMutationResult] =
    useRemoveBulkAggregateProductsMutation();
  const [productByIdMutation, productByIdMutationResult] =
    useGetProductByIdMutation();
  const [quickSyncMutation, quickSyncMutationResult] = useQuickSyncMutation();
  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
    setProductAggSelectedRows([]);
    if (newValue === "Wholegoods") {
      getSyncStatusMutation({ type: ProductType.Whoolgoods });
      setProductType(0);
    } else if (newValue === "Parts") {
      getSyncStatusMutation({ type: ProductType.Parts });
      setProductType(1);
    }
  };

  const handleDeleteProduct = () => {
    setProductDeleteConfirm(false);
    deleteProductMutation({ aggregateId: selectedProductId }).then(
      (res: any) => {
        if (res.data && res.data.status === 200) {
          if (productType === 0) {
            fetchWholegoodData();
          } else if (productType === 1) {
            fetchPartsData();
          }
        }
      }
    );
  };

  const handleDeleteBulkProducts = () => {
    setDeleteBulkProductsConfirm(false);
    deleteBulkProductsMutation({
      ProductAggregateIds: productAggSelectedRows,
    }).then((res: any) => {
      if (res.data && res.data.status === 200) {
        setProductAggSelectedRows([]);
        if (productType === 1) {
          fetchPartsData();
        } else {
          fetchWholegoodData();
        }
      }
    });
  };

  const handleGetProductDetail = (catalogId: any) => {
    setOpenDetail(true);
    productByIdMutation({
      data: { id: catalogId },
    }).then((res: any) => {
      if (res.data.status === 0) {
        setSelectedProductDetail(res.data.entity);
      } else {
        setOpenDetail(false);
      }
    });
  };
  const onConfirmSyncing = () => {
    setOpenSync(false);
    setSyncingStatus(true);
  };
  const fetchWholegoodData = () => {
    getWholegoodsAggregate({
      setupId: dmsSetup?.id ?? "",
      paging: paging,
      productType: productType,
    });
  };
  const fetchPartsData = () => {
    getPartsAggregate({
      setupId: dmsSetup?.id ?? "",
      paging: partsPaging,
      productType: productType,
    });
  };
  const fetchData = () => {
    shopifyProductsMutation({
      setupId: dmsSetup?.id ?? "",
      paging: shopifyPaging,
    });
  };

  const handleClose = () => {
    setProductDeleteConfirm(false);
    setOpenSync(false);
    setPopup(false);
    setOpenDetail(false);
    setDeleteBulkProductsConfirm(false);
  };

  React.useEffect(() => {
    if (productType === 1) {
      fetchPartsData();
    } else {
      fetchWholegoodData();
    }
  }, [paging, productType, partsPaging]);

  React.useEffect(() => {
    if (getSyncStatusMutationResult.isSuccess) {
      setCounts({
        ...counts,
        totalCount: getSyncStatusMutationResult.data.entity.totalCount,
        syncedCount: getSyncStatusMutationResult.data.entity.syncedCount,
        isPartSyncing: getSyncStatusMutationResult.data.entity.isPartSyncing,
        isWholegoodSyncing:
          getSyncStatusMutationResult.data.entity.isWholegoodSyncing,
      });
    }
  }, [getSyncStatusMutationResult]);

  React.useEffect(() => {
    getSyncStatusMutation({ type: ProductType.Whoolgoods });
  }, []);

  React.useEffect(() => {
    if (popup) {
      fetchData();
    }
  }, [shopifyPaging]);

  React.useEffect(() => {
    if (
      addShopifyToAggregateMutationResult.data &&
      addShopifyToAggregateMutationResult.isSuccess &&
      addShopifyToAggregateMutationResult.data.status === 200
    ) {
      addShopifyToAggregateMutationResult.data.entity.type === "Wholegoods"
        ? setProducts(products.filter((prod) => prod.id !== selectedRowData.id))
        : setParts(parts.filter((prod) => prod.id !== selectedRowData.id));
      setCounts({ ...counts, syncedCount: counts.syncedCount + 1 });
    }
  }, [addShopifyToAggregateMutationResult]);

  const onSyncProductAction = (id: number, handle: string) => {
    addShopifyToAggregate({
      aggregateId: selectedRowData.id,
      handle: handle,
      shopifyProductId: id,
    });
  };

  React.useEffect(() => {
    if (shopifyProductsMutationResult.data) {
      setShopifyProducts(shopifyProductsMutationResult.data.entity.productDto);
      setShopifyProductsCount(shopifyProductsMutationResult.data.totalRecords);
    }
  }, [shopifyProductsMutationResult]);
  const columns: GridColDef[] = [
    {
      field: "manufacturer",
      headerName: "Manufacturer",
      flex: 1,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Tooltip title={params.row.manufacturer}>
            <Typography sx={{ fontSize: "0.875rem" }}>
              {params.row.manufacturer}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: "title",
      headerName: "Title",
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params.row.title}>
          <Link
            component={Link}
            underline="none"
            sx={{ cursor: "pointer" }}
            onClick={() => {
              handleGetProductDetail(
                params?.row?.catalogProductId ?? params?.row?.productId
              );
            }}
          >
            {params.row.title}
          </Link>
        </Tooltip>
      ),
    },
    {
      field: "model",
      headerName: "DMS Model",
      flex: 1,
      valueGetter: (params: GridValueGetterParams<any>) => params.row.model,
    },
    {
      field: "modelNumber",
      headerName: "Catalog Model Number",
      flex: 1,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.modelNumber,
    },
    {
      field: "price",
      headerName: "Price ($)",
      headerAlign: "right",
      flex: 1,
      align: "right",
      type: "number",
      sortable: true,
      filterOperators: customPriceFilterOperators,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.price.toFixed(2),
    },
    {
      field: "cost",
      headerName: "Cost ($)",
      headerAlign: "right",
      flex: 1,
      align: "right",
      type: "number",
      filterable: false,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.cost.toFixed(2),
    },
    {
      field: "stock",
      headerName: "Stock",
      headerAlign: "right",
      flex: 1,
      align: "right",
      type: "number",
      filterable: false,
      valueGetter: (params: GridValueGetterParams<any>) => {
        if (params.row.stock) {
          return params.row?.stock?.reduce(
            (partial: number, value: any) => partial + value.stock,
            0
          );
        }
      },
    },
    {
      field: "isExistingProduct",
      headerName: "Sync Type",
      headerAlign: "center",
      flex: 1,
      align: "center",
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        return params?.row?.isExistingProduct ? (
          <Chip label="Reverse" color="warning" size="small" />
        ) : (
          <Chip label="Regular" color="success" size="small" />
        );
      },
    },
    {
      field: "isStocking",
      headerName: "Stocking Type",
      headerAlign: "center",
      flex: 1,
      align: "center",
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        return params?.row?.isStocking ? (
          <Chip label="Stocking" color="success" size="small" />
        ) : (
          <Chip label="Non Stocking" color="warning" size="small" />
        );
      },
    },
    {
      field: "actions",
      headerName: "Status",
      type: "actions",
      flex: 1,
      renderCell: (params: GridRenderCellParams) => {
        return params.row?.shopifyProductId > 0 ? (
          <Chip
            size="small"
            label="View"
            color="success"
            onClick={() => {
              window.open(
                `${dmsSetup?.shopifyUrl}/products/${params.row?.shopifyProductLink}`,
                "_blank"
              );
            }}
          />
        ) : (
          <Chip size="small" label="Pending" color="primary" />
        );
      },
    },
    {
      field: "sync",
      headerName: "Quick Sync",
      type: "actions",
      flex: 1,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Button
            disabled={
              counts.isPartSyncing ||
              counts.isWholegoodSyncing ||
              quickSyncMutationResult.isLoading ||
              dmsSetup?.syncExisting ||
              params.row?.shopifyProductId > 0
            }
            color="warning"
            variant="contained"
            size="small"
            sx={{ fontSize: "0.7rem" }}
            onClick={() => {
              onQuickSync(params.row.id);
            }}
          >
            Sync Now
          </Button>
        );
      },
    },
    {
      field: "delete",
      headerName: "Delete",
      type: "actions",
      flex: 1,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Button
            color="error"
            disabled={params.row?.shopifyProductId > 0}
            variant="contained"
            size="small"
            sx={{ fontSize: "0.7rem" }}
            onClick={() => {
              setSelectedProductId(params.row.id);
              setProductDeleteConfirm(true);
            }}
          >
            Delete
          </Button>
        );
      },
    },
  ];

  const partsColumns: GridColDef[] = [
    {
      field: "manufacturer",
      headerName: "Manufacturer",
      flex: 1,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Tooltip title={params.row.manufacturer}>
            <Typography sx={{ fontSize: "0.875rem" }}>
              {params.row.manufacturer}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: "inventoryPartId",
      headerName: "Part Id",
      flex: 1,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Typography
            onClick={(e) => {}}
            sx={{ cursor: "pointer" }}
            color="primary"
          >
            {params.row.inventoryPartId}
          </Typography>
        );
      },
    },
    {
      field: "partNumber",
      headerName: "Part Number",
      flex: 1,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.partNumber,
    },

    {
      field: "price",
      headerName: "Price ($)",
      headerAlign: "right",
      flex: 1,
      align: "right",
      type: "number",
      sortable: true,
      filterOperators: customPriceFilterOperators,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.price.toFixed(2),
    },
    {
      field: "cost",
      headerName: "Cost ($)",
      headerAlign: "right",
      flex: 1,
      align: "right",
      type: "number",
      filterable: false,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.cost.toFixed(2),
    },
    {
      field: "stock",
      headerName: "Stock",
      headerAlign: "right",
      flex: 1,
      align: "right",
      type: "number",
      filterable: false,
      valueGetter: (params: GridValueGetterParams<any>) => {
        if (params.row.stock) {
          return params.row?.stock?.reduce(
            (partial: number, value: any) => partial + value.stock,
            0
          );
        }
      },
    },
    {
      field: "isExistingProduct",
      headerName: "Sync Type",
      headerAlign: "center",
      flex: 1,
      align: "center",
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        return params?.row?.isExistingProduct ? (
          <Chip label="Reverse" color="warning" size="small" />
        ) : (
          <Chip label="Regular" color="success" size="small" />
        );
      },
    },
    {
      field: "isStocking",
      headerName: "Stocking Type",
      headerAlign: "center",
      flex: 1,
      align: "center",
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        return params?.row?.isStocking ? (
          <Chip label="Stocking" color="success" size="small" />
        ) : (
          <Chip label="Non Stocking" color="warning" size="small" />
        );
      },
    },
    {
      field: "actions",
      headerName: "Status",
      type: "actions",
      flex: 1,
      renderCell: (params: GridRenderCellParams) => {
        return params.row?.shopifyProductId > 0 ? (
          <Chip
            size="small"
            label="View"
            color="success"
            onClick={() => {
              window.open(
                `${dmsSetup?.shopifyUrl}/products/${params.row?.shopifyProductLink}`,
                "_blank"
              );
            }}
          />
        ) : (
          <Chip size="small" label="Pending" color="primary" />
        );
      },
    },
    {
      field: "sync",
      headerName: "Quick Sync",
      type: "actions",
      flex: 1,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Button
            disabled={
              counts.isPartSyncing ||
              counts.isWholegoodSyncing ||
              quickSyncMutationResult.isLoading ||
              dmsSetup?.syncExisting ||
              params.row?.shopifyProductId > 0
            }
            color="warning"
            variant="contained"
            size="small"
            sx={{ fontSize: "0.7rem" }}
            onClick={() => {
              onQuickSync(params.row.id);
            }}
          >
            Sync Now
          </Button>
        );
      },
    },
    {
      field: "delete",
      headerName: "Delete",
      type: "actions",
      flex: 1,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Button
            color="error"
            disabled={params.row?.shopifyProductId > 0}
            variant="contained"
            size="small"
            sx={{ fontSize: "0.7rem" }}
            onClick={() => {
              setSelectedProductId(params.row.id);
              setProductDeleteConfirm(true);
            }}
          >
            Delete
          </Button>
        );
      },
    },
  ];

  const shopifyColumns: GridColDef[] = [
    {
      field: "title",
      headerName: "Title",
      flex: 1,
      valueGetter: (params: GridValueGetterParams<any>) => params.row.title,
    },
    {
      field: "variants[0].sku",
      headerName: "SKU",
      flex: 1,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.variants[0].sku,
    },
    {
      field: "variants[0].price",
      headerName: "Price ($)",
      headerAlign: "right",
      flex: 1,
      align: "right",
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.variants[0].price.toFixed(2),
    },
    {
      field: "status",
      headerName: "Status",
      align: "center",
      headerAlign: "center",
      flex: 1,
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        return getStatusChip(params.row.status);
      },
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Action",
      flex: 1,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <div>
            <IconButton
              id="basic-button"
              onClick={(n) => {
                onSyncProductAction(params.row.id, params.row.handle);
                setPopup(false);
              }}
            >
              <AddCircleIcon />
            </IconButton>
          </div>
        );
      },
    },
  ];

  const setSyncingStatus = (isSyncing: boolean) => {
    setSyncingMutation({
      pricing: priceType,
      dmsSetupId: setupId ?? "",
      setSyncing: isSyncing,
      productType: productType,
    });
  };

  React.useEffect(() => {
    if (isSyncing) {
      setNextSync();
    }
  }, [isSyncing]);

  React.useEffect(() => {
    setPriceType(PricingType.Price);
    if (setSyncingMutationResult.isSuccess) {
      setCounts({
        ...counts,
        isPartSyncing:
          productType === ProductType.Parts
            ? setSyncingMutationResult.data.entity?.isSyncing
            : counts.isPartSyncing,
        isWholegoodSyncing:
          productType === ProductType.Whoolgoods
            ? setSyncingMutationResult.data.entity?.isSyncing
            : counts.isWholegoodSyncing,
      });
    }
  }, [setSyncingMutationResult]);

  React.useEffect(() => {
    if (getWholegoodsAggregateResult.data) {
      setProducts(getWholegoodsAggregateResult.data.entityList);
      setProductsCount(getWholegoodsAggregateResult.data.totalRecords);
      let ids = getWholegoodsAggregateResult.data.entityList
        .filter((n: any) => n.shopifyProductId === 0)
        .map((item: any) => item.id as string);
      setProductToSync({
        productIds: ids,
        selectedProductId: "",
      });
    }
  }, [getWholegoodsAggregateResult]);

  React.useEffect(() => {
    if (getPartsAggregateResult.data) {
      setParts(getPartsAggregateResult.data.entityList);
      setPartsCount(getPartsAggregateResult.data.totalRecords);
    }
  }, [getPartsAggregateResult]);

  React.useEffect(() => {
    if (productToSync.productIds.length === 0) {
      setIsSyncing(false);
    }
  }, [productToSync]);

  const setNextSync = () => {
    let productAggregateId = productToSync.productIds[0] ?? "";
    setProductToSync({
      ...productToSync,
      selectedProductId: productAggregateId,
    });
  };

  const updateData = (data: any) => {
    if (data.type === "Wholegoods") {
      setProducts(
        products.map((item: any) =>
          item.id == data.id
            ? {
                ...item,
                shopifyProductId: data.shopifyProductId,
                shopifyProductLink: data.shopifyProductLink,
                isShopifySync: true,
              }
            : item
        )
      );
    } else {
      setParts(
        parts.map((item: any) =>
          item.id == data.id
            ? {
                ...item,
                shopifyProductId: data.shopifyProductId,
                shopifyProductLink: data.shopifyProductLink,
                isShopifySync: true,
              }
            : item
        )
      );
    }
    if (data.id !== "00000000-0000-0000-0000-000000000000") {
      setCounts({ ...counts, syncedCount: counts.syncedCount + 1 });
    }
  };

  React.useEffect(() => {
    if (
      syncedProductAggregateEventData &&
      syncedProductAggregateEventData.productAggregate
    ) {
      updateData(syncedProductAggregateEventData.productAggregate);
      dispatch(
        setSyncStatus({
          isSyncing: syncedProductAggregateEventData.isSyncing,
          productType: syncedProductAggregateEventData.productAggregate.type,
        })
      );
      setIsSyncing(syncedProductAggregateEventData.isSyncing);
    }
  }, [syncedProductAggregateEventData]);

  const onQuickSync = (productId: string) => {
    quickSyncMutation({ productId }).then((res: any) => {
      if (res?.data?.status === 200) {
        if (productType === 1) {
          fetchPartsData();
        } else {
          fetchWholegoodData();
        }
      }
    });
  };

  return (
    <>
      <Container maxWidth={false}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={1}
        >
          <Typography variant="h6" sx={{ fontWeight: "bold" }} gutterBottom>
            Product Sync
          </Typography>

          {value === "Shopify" ? (
            <Select
              value={shopifyProductStatus}
              sx={{ width: "130px" }}
              onChange={handleSelectChange}
              variant="standard"
            >
              <MenuItem selected value="all">
                All
              </MenuItem>
              <MenuItem value="active">Active</MenuItem>
              <MenuItem value="archived">Archived</MenuItem>
              <MenuItem value="draft">Draft</MenuItem>
            </Select>
          ) : dmsSetup?.syncExisting ? (
            ""
          ) : isProductSyncing(
              productType,
              counts.isWholegoodSyncing,
              counts.isPartSyncing
            ) && counts.syncedCount < counts.totalCount ? (
            <>
              <Button
                disabled={setSyncingMutationResult.isLoading}
                color="warning"
                variant="contained"
                onClick={() => {
                  setSyncingStatus(false);
                }}
                startIcon={<CircularProgress size="1.2rem" color="inherit" />}
              >
                Stop Syncing
              </Button>
            </>
          ) : (
            <Box display={"flex"} flexDirection={"column"}>
              <Button
                disabled={
                  setSyncingMutationResult.isLoading ||
                  counts.syncedCount === counts.totalCount ||
                  counts.isPartSyncing ||
                  counts.isWholegoodSyncing
                }
                color="warning"
                variant="contained"
                onClick={() => {
                  setOpenSync(true);
                }}
                startIcon={<SyncIcon />}
              >
                Start {productType === ProductType.Parts ? "Part" : "Wholegood"}{" "}
                Sync
              </Button>
              <Link
                component={Button}
                underline="none"
                disabled={
                  productAggSelectedRows.length === 0 ||
                  deleteBulkProductsMutationResult.isLoading
                }
                onClick={() => setDeleteBulkProductsConfirm(true)}
                color={"error"}
                variant="body2"
              >
                Bulk Delete
              </Link>
            </Box>
          )}
        </Stack>
        <Card>
          <CardContent sx={{ padding: 0, paddingBottom: "0px !important" }}>
            <TabContext value={value.toString()}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <TabList onChange={handleTabChange}>
                  {productTypes?.some((n) => n === "Wholegoods") && (
                    <Tab label={"Wholegoods"} value={"Wholegoods"} />
                  )}
                  {productTypes?.some((n) => n === "Parts") && (
                    <Tab label={"Parts"} value={"Parts"} />
                  )}

                  <Tab label={"Shopify"} value={"Shopify"} />
                </TabList>
              </Box>

              {
                <TabPanel value="Wholegoods" style={{ padding: 0 }}>
                  <Box p={1}>
                    <ProgressBar
                      value={getPercentage(
                        counts.totalCount,
                        counts.syncedCount
                      )}
                    />
                  </Box>
                  <ServerAppGrid
                    data={products}
                    columns={GetAppGridColumns(
                      dmsSetup?.syncExisting
                        ? columns.filter((col) => col.field !== "sync")
                        : columns,
                      WGgridSetting?.columnVisibilityModel
                    )}
                    isLoading={
                      getWholegoodsAggregateResult.isLoading ||
                      deleteProductMutationResult.isLoading
                    }
                    selectedRows={productAggSelectedRows}
                    onSelect={(newSelected: any) => {
                      setProductAggSelectedRows(newSelected);
                    }}
                    paging={paging}
                    setPaging={setPaging}
                    totalRecords={productsCount}
                    keepNonExistentRowsSelected={true}
                    gridId={AppGridId.Product_Sync_Wholegoods}
                    height={"70vh"}
                  ></ServerAppGrid>
                </TabPanel>
              }
              <TabPanel value="Parts" style={{ padding: 0 }}>
                <Box p={1} sx={{ width: "100%" }}>
                  <ProgressBar
                    value={getPercentage(counts.totalCount, counts.syncedCount)}
                  />
                </Box>
                <ServerAppGrid
                  data={parts}
                  columns={GetAppGridColumns(
                    dmsSetup?.syncExisting
                      ? partsColumns.filter((col) => col.field !== "sync")
                      : partsColumns,
                    PartgridSetting?.columnVisibilityModel
                  )}
                  isLoading={
                    getPartsAggregateResult.isLoading ||
                    deleteProductMutationResult.isLoading
                  }
                  selectedRows={productAggSelectedRows}
                  onSelect={(newSelected: any) => {
                    setProductAggSelectedRows(newSelected);
                  }}
                  paging={partsPaging}
                  setPaging={setPartsPaging}
                  totalRecords={partsCount}
                  keepNonExistentRowsSelected={true}
                  gridId={AppGridId.Product_Sync_Parts}
                  height={"70vh"}
                ></ServerAppGrid>
              </TabPanel>
              <TabPanel value="Shopify" style={{ padding: 0 }}>
                <ShopifyProductGrid
                  ShopifyProductStatus={shopifyProductStatus}
                ></ShopifyProductGrid>
              </TabPanel>
            </TabContext>
          </CardContent>
        </Card>
      </Container>

      <Dialog open={productDeleteConfirm} onClose={handleClose}>
        <DialogTitle id="draggable-dialog-title">
          Confirm to Delete Product
        </DialogTitle>
        <DialogContent>
          This action will delete this product from aggregate and will not
          available to sync with shopify.
        </DialogContent>
        <DialogActions>
          <Button
            size="small"
            variant="outlined"
            onClick={() => {
              setProductDeleteConfirm(false);
            }}
          >
            No
          </Button>
          <Button
            size="small"
            variant="contained"
            onClick={handleDeleteProduct}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteBulkProductsConfirm} onClose={handleClose}>
        <DialogTitle id="draggable-dialog-title">
          Confirm to Delete Products
        </DialogTitle>
        <DialogContent>
          This action will delete all the selected products from aggregate and
          will not available to sync with shopify.
        </DialogContent>
        <DialogActions>
          <Button
            size="small"
            variant="outlined"
            onClick={() => {
              setDeleteBulkProductsConfirm(false);
            }}
          >
            No
          </Button>
          <Button
            size="small"
            variant="contained"
            onClick={handleDeleteBulkProducts}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openSync} onClose={handleClose} fullWidth>
        <DialogTitle sx={{ textAlign: "center" }}>Confirm Syncing</DialogTitle>
        <DialogContent>
          <Grid item xs={12} sm={6}>
            <Select
              value={priceType}
              onChange={(e, value) => {
                setPriceType(e.target.value as PricingType);
              }}
              fullWidth
              name="pricing"
              variant="standard"
            >
              <MenuItem value={PricingType.Price}>Price</MenuItem>
            </Select>
          </Grid>
          <Typography mt={3}>
            Your are going to sync{" "}
            {dmsSetup?.syncExisting
              ? "only Exisiting shopify Products"
              : " from Target Web to Shopify"}
            . If you want to change,
            <Link href="/SetupProfile">Click here</Link>
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            size="small"
            variant="outlined"
            onClick={() => {
              setOpenSync(false);
            }}
          >
            Cancel
          </Button>
          <Button size="small" variant="contained" onClick={onConfirmSyncing}>
            Start
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={popup}
        onClose={handleClose}
        maxWidth={"lg"}
        fullWidth
        className="check"
      >
        <DialogTitle alignSelf={"center"}>Shopify Products</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <Card>
            <ServerAppGrid
              data={shopifyProducts}
              columns={shopifyColumns}
              isLoading={shopifyProductsMutationResult.isLoading}
              paging={shopifyPaging}
              setPaging={setShopifyPaging}
              customPagesize={[10, 20, 50]}
              totalRecords={shopifyProductsCount}
              keepNonExistentRowsSelected={false}
            ></ServerAppGrid>
          </Card>
        </DialogContent>
      </Dialog>
      <ProductDetail
        isOpen={openDetail}
        handleClose={handleClose}
        productData={selectedProductDetail}
        Loading={productByIdMutationResult.isLoading}
      />
    </>
  );
};

export default SyncProduct;

function ProgressBar(props: LinearProgressProps & { value: number }) {
  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Box sx={{ width: "100%", mr: 1 }}>
        <LinearProgress
          sx={{ height: 5, borderRadius: 5 }}
          variant="determinate"
          {...props}
        />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" color="text.secondary">{`${Math.round(
          props.value
        )}%`}</Typography>
      </Box>
    </Box>
  );
}
const getPercentage = (total: number, synced: number) => {
  return total > 0 ? (synced / total) * 100 : 0;
};

const getStatusChip = (status: string) => {
  if (status.toLowerCase() === "active")
    return <Chip label="Active" color="success" size="small" />;
  else return <Chip label="Draft" color="error" size="small" />;
};

const isProductSyncing = (
  productType: ProductType,
  isWholegoodSyncing: boolean,
  isPartSyncing: boolean
) => {
  switch (productType) {
    case ProductType.Whoolgoods:
      return isWholegoodSyncing;
    case ProductType.Parts:
      return isPartSyncing;
    default:
      return false;
  }
};
